import React from 'react';
import loadingArrayList from 'constants/loadingArray';
import SkeletonProfileStickerSmall from 'components/Suspense/Skeleton/SkeletonProfileStickerSmall';

const LoadingProfileStickerSmallList = () => {
  const loadingArr = loadingArrayList.default;
  return (
    <>
      <div className="sort-by relative height-auto">
        <div className="category sticky padding-row-8 padding-col-12 background-white">Artist</div>
        <ul className="sticker-list padding-col-4">
          {loadingArr.map(idx => (
            <SkeletonProfileStickerSmall key={idx} />
          ))}
        </ul>
      </div>
      <div className="sort-by relative height-auto">
        <div className="category sticky padding-row-8 padding-col-12 background-white">Art work</div>
        <ul className="sticker-list padding-col-4">
          {loadingArr.map(idx => (
            <SkeletonProfileStickerSmall key={idx} />
          ))}
        </ul>
      </div>
    </>
  );
};

export default LoadingProfileStickerSmallList;
